import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { ArrowLeft, LifeBuoy, Edit3 } from 'lucide-react';
import { helpAPI } from '../api/client';
import { usePermissions } from '../context/PermissionsContext';
import Markdown from '../components/Markdown';

export default function HelpArticle() {
  const { slug } = useParams();
  const nav = useNavigate();
  const { hasPermission } = usePermissions();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true); setError(null);
    helpAPI.getArticle(slug)
      .then(r => setArticle(r.data))
      .catch(e => setError(e.response?.data?.message || 'Article not found'))
      .finally(() => setLoading(false));
  }, [slug]);

  return (
    <div className="p-6">
      <button onClick={() => nav('/help')} className="inline-flex items-center gap-2 text-sm text-gray-600 hover:text-gray-900 mb-4">
        <ArrowLeft className="w-4 h-4" /> All articles
      </button>

      {loading && <div className="text-gray-500">Loading…</div>}
      {error && <div className="bg-red-50 border border-red-200 rounded p-4 text-red-700">{error}</div>}

      {article && (
        <article className="bg-white border border-gray-200 rounded-2xl p-8 shadow-sm">
          <div className="flex justify-between items-start gap-4">
            <div>
              <div className="text-xs text-blue-600 font-medium uppercase tracking-wide">{article.CategoryTitle}</div>
              <h1 className="text-3xl font-bold text-gray-900 mt-1">{article.Title}</h1>
              {article.Summary && <p className="text-gray-600 mt-2">{article.Summary}</p>}
            </div>
            {hasPermission('manage_help') && (
              <Link to={`/help/manage/${article.ArticleID}`} className="inline-flex items-center gap-1.5 text-sm border px-3 py-1.5 rounded-md hover:bg-gray-50">
                <Edit3 className="w-4 h-4" /> Edit
              </Link>
            )}
          </div>
          <hr className="my-6 border-gray-100" />
          <Markdown source={article.BodyMarkdown} className="prose-spocodoc" />
          <hr className="my-8 border-gray-100" />
          <div className="bg-blue-50 border border-blue-100 rounded-xl p-5 flex items-center justify-between">
            <div>
              <div className="font-semibold text-gray-900">Still need a hand?</div>
              <div className="text-sm text-gray-600">Send us a ticket and we'll get back to you.</div>
            </div>
            <Link to="/support/new" className="inline-flex items-center gap-2 bg-blue-600 text-white px-4 py-2 rounded-md text-sm hover:bg-blue-700">
              <LifeBuoy className="w-4 h-4" /> Contact support
            </Link>
          </div>
        </article>
      )}
    </div>
  );
}
